import { OAUTH2_POPUP_CALLBACK_MESSAGE_TYPE, type OAuth2PopupCallbackMessageData } from './oauth2PopupPostMessage';

/**
 * Subscribe to OAuth2 popup callback messages from the same origin.
 * Call the returned function to unsubscribe.
 */
export const listenForOAuth2PopupCallback = (handler: (data: OAuth2PopupCallbackMessageData) => void): (() => void) => {
    const onMessage = (event: MessageEvent): void => {
        if (event.origin !== window.location.origin) {
            return;
        }
        const data = event.data as OAuth2PopupCallbackMessageData | undefined;
        if (!data || data.type !== OAUTH2_POPUP_CALLBACK_MESSAGE_TYPE) {
            return;
        }
        handler(data);
    };

    window.addEventListener('message', onMessage);
    return () => window.removeEventListener('message', onMessage);
};
